import * as types from './mutation-types'

export const actions = {

    async cartClean({ commit, dispatch, getters, rootGetters }, payload) {
        commit(types.CART_CLEAN)
    }    
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/cart/actions.js
// module id = null
// module chunks = 